export default __webpack_public_path__ + "static/media/hedvig.3fcd0a7e.png";